import {AnyNotFound} from './AnyNotFound';

export const PageNotFound = () => <AnyNotFound />;
